import { render } from "./px-notice.vue?vue&type=template&id=6e0701f6&scoped=true&ts=true"
import script from "./px-notice.vue?vue&type=script&lang=ts"
export * from "./px-notice.vue?vue&type=script&lang=ts"

import "./px-notice.vue?vue&type=style&index=0&id=6e0701f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0701f6"]])

export default __exports__